import { motion } from 'framer-motion';
import { Shield, TrendingUp, Home, PiggyBank } from 'lucide-react';

const pillars = [
  { icon: Shield, title: 'Absicherung', text: 'Wir setzen für Existenz, Gesundheit und Vermögen den Rahmen in dem sich unsere Mandanten sicher bewegen können.' },
  { icon: PiggyBank, title: 'Altersvorsorge', text: 'Wir bauen mit unseren Mandanten Vorsorgekonzepte die vom Berufseinstieg bis zur Rente über 40 Jahre tragen.' },
  { icon: TrendingUp, title: 'Vermögensaufbau', text: 'Wir erklären ETFs, Depots, Kapitalanlageimmobilien und Private Equity so klar, dass unsere Mandanten langfristig verstehen was mit ihrem Geld passiert.' },
  { icon: Home, title: 'Finanzierung', text: 'Wir finanzieren Immobilien mit deutschlandweit vergleichbaren Konditionen statt mit dem was eine einzelne Hausbank gerade auf dem Tisch hat.' },
];

const WasWirMachen = () => {
  return (
    <section className="section-warm py-20 md:py-28">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mb-14">
          <p className="text-[11px] uppercase tracking-[0.22em] text-primary-dark font-semibold mb-4">Was wir machen</p>
          <h2 className="font-normal text-foreground mb-6">
            Ganzheitliche, unabhängige <span className="italic text-primary-dark">Finanzberatung.</span>
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Wir beraten Menschen die überdurchschnittlich verdienen und komplexe finanzielle Fragen mitbringen, allen voran Mediziner, Ingenieure und Apotheker. Für diese Zielgruppen haben wir mit{' '}
            <a href="https://pharmakademie.com" target="_blank" rel="noopener" className="text-primary-dark underline hover:no-underline">Pharmakademie</a>,{' '}
            <a href="https://finanzakademien.de/mediakademie" target="_blank" rel="noopener" className="text-primary-dark underline hover:no-underline">MediAkademie</a> und{' '}
            <a href="https://finanzakademien.de/ingenieursakademie" target="_blank" rel="noopener" className="text-primary-dark underline hover:no-underline">IngenieursAkademie</a> eigene Marken aufgebaut, und bei uns bekommst du die Plattform um genau das mitzugestalten.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {pillars.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="premium-card p-6"
            >
              <div className="w-11 h-11 rounded-xl bg-primary/15 text-primary-dark flex items-center justify-center mb-4">
                <p.icon className="w-5 h-5" strokeWidth={1.8} />
              </div>
              <h3 className="font-serif text-lg text-foreground mb-2">{p.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{p.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WasWirMachen;
